import '../App.less';
import { Layout, Row, Col,ConfigProvider,Card } from 'antd';
import React, { Component } from "react";
import cabezal from './Cabezal.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import { Button } from 'antd';
import Foot from "./components/Footer"

class Home extends Component {
  render() {
    return (
      <div className="page-container">
      <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
          <Layout style={{backgroundColor:'white'}}>
            <Row>
              <Col><NavLink to="/casa"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
            </Row>
          <Row justify="center" align="middle" >
            <Col xs={{span:24}} sm={{span:18}}>
              <Card title='Premio Literario Casa de las Américas' bordered={false}>
                <p>Durante sus más de sesenta años de existencia, este Premio, el más antiguo de su tipo en el Continente,
                  ha sido reflejo de la historia y la cultura de la América Latina y el Caribe. Nacido con el nombre de Concurso
                  Literario Hispanoamericano, adoptó en 1964, con la entrada de autores brasileños, el de Concurso Literario Latinoamericano, 
                  y a partir del año siguiente el nombre definitivo de Premio Literario Casa de las Américas o, simplemente, Premio Casa de las Américas. 
                </p>
                <p>Desde su primera edición en enero de 1960, en la cual fueron jurados desde escritores consagrados como Miguel Ángel Asturias, Nicolás Guillén
                  y Alejo Carpentier, hasta jóvenes promesas como Carlos Fuentes, el certamen ha contado con la presencia de más de mil intelectuales de varios 
                  continentes, y más de veinte mil en calidad de concursates. Muchos autores a quienes la vida condujo por los más disímiles rumbos (Juan José Arreola, 
                  Mario Benedetti, Kamau Brathwaite, Italo Calvino, Antonio Candido, Ernesto Cardenal, Fernando Henrique Cardoso, Camilo José Cela, Julio Cortázar, 
                  René Depestre, María Rosa Oliver, Nélida Piñón, Ángel Rama, José Saramago y Mario Vargas Llosa, entre tantos otros) han legitimado, al participar 
                  como jurados en él, un premio empeñado en apoyar, inclusive, la creación en géneros no canónicos o en otras lenguas de nuestra América, además de 
                  estimular el esfuerzo de los nuevos escritores. De hecho, autores como Roque Dalton, Ricardo Piglia, Alfredo Bryce Echenique, Antonio Skármeta y Eduardo
                  Galeano daban sus primeros pasos en la literatura cuando fueron galardonados y publicados por la Casa.</p>
                <p>Además de la misión de difundir la obra de los escritores galardonados, el Premio se propuso ser lugar de encuentro de los escritores de todo el mundo y en 
                  especial de nuestra región. De hecho, la Casa y su concurso trenzaron efectivas redes  intelectuales. Aquí se conocieron personalmente gran parte de los autores
                  y aquí esbozaron muchas de sus ideas más fecundas. Fiel a esa tradición, el Premio continúa siendo espacio privilegiado de encuentro y promoción de la literatura
                    de y sobre nuestra América.</p>
                <Row justify="center" align="middle" gutter={24}>
                  <Col xs={{span:19}} sm={{span:24}} >
                    <Button disabled  style={{backgroundColor:'gray', color:'white', width:'350px'}}><NavLink to="/casa/registro">Registro finalizado</NavLink></Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Layout>
      </ConfigProvider>
    </div>
   <Foot/>
</div>
    );
  }
}
export default Home;


